module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-13.fe139aff.png";